import { batchUpdateSalesProjection } from "./batchUpdate";

export const salesProjectionService = {
    batchUpdate: batchUpdateSalesProjection,
};

export * from "./batchUpdate";
